// src/contexts/pedidos/ConfigPedidoContext.js
import React, { createContext, useContext, useState, useEffect } from 'react';
import { fetchData, putData } from '../../services/Api';
import { useAlert } from '../geral/AlertContext';
import ConfigPedidoCad from '../../pages/pedidos/ConfigPedidoCad';

const ConfigPedidoContext = createContext();

export const useConfigPedido = () => useContext(ConfigPedidoContext);

export const ConfigPedidoProvider = ({ children }) => {
    const [configPedido, setConfigPedido] = useState();
    const { showAlert } = useAlert();

    useEffect(() => {
        const fetchDataFromAPI = async () => {
            try {
                const result = await fetchData('/ConfigPedido');
                setConfigPedido(result);
            } catch (error) {
                console.error('Erro ao buscar configurações de Pedido:', error);
            }
        };
        fetchDataFromAPI();
    }, []);

    const updateConfigPedido = async (configPedido, options = {}) => {
        const { showSuccessMessage = true, showErrorMessage = true } = options;

        try {
            const result = await putData('/ConfigPedido', configPedido);
            setConfigPedido(result);

            if (showSuccessMessage) {
                showAlert('Configuração de Pedido alterada com sucesso!');
            }

            return result;
        } catch (error) {
            console.error('Erro ao atualizar configuração de Pedido:', error);

            if (showErrorMessage) {
                showAlert('Erro ao alterar configuração de Pedido!', 'danger');
            }

            throw error;
        }
    };

    // Modal Cadastro Config pedido
    const [showModalConfigPedido, setShowModalConfigPedido] = useState(false);
    const showConfigPedidoCad = () => {
        setShowModalConfigPedido(true);
    };

    const handleCloseModalCliente = () => {
        setShowModalConfigPedido(false);
    };

    return (
        <ConfigPedidoContext.Provider value={{ configPedido, setConfigPedido, updateConfigPedido, showConfigPedidoCad }}>
            {children}
            <ConfigPedidoCad
                show={showModalConfigPedido}
                onHide={handleCloseModalCliente}
            />
        </ConfigPedidoContext.Provider>
    );
};
